var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128035(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-128_035-1{fill:#fafafa;}.cls-128_035-2,.cls-128_035-3,.cls-128_035-4{fill:none;}.cls-128_035-2{opacity:0.2;}.cls-128_035-3{stroke:#6e6e6e;}.cls-128_035-3,.cls-128_035-4{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}.cls-128_035-4{stroke:#ff6a10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128_035-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128_035-2",
    width: 128,
    height: 128
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_035-3",
    d: "M99.4,52.55c-.5-.09-5.06-1.46-6.75,6.45l-.43,1.52a1.44,1.44,0,0,1-1.65,1.13h0a1.9,1.9,0,0,1-1.59-2l.4-4c0-3.05-1-4.88-3.72-5.92a6.05,6.05,0,0,0-2.15-.38h-.37c-3.47,0-5.86,2.83-5.86,6.3l-.1,2.72A1.69,1.69,0,0,1,75.84,60a1.67,1.67,0,0,1-2-1.63l0-6.14a6.49,6.49,0,0,0-6.31-6.3h0a6.32,6.32,0,0,0-6.3,6.3l.43,7.91a1.36,1.36,0,0,1-1.2,1.44h0a1.37,1.37,0,0,1-1.52-1.2L56.29,16.94C56,13.31,55,9,50.71,8.89c-5.68,0-6.18,6.32-6.08,8.64l1.75,59A.76.76,0,0,1,45,77L34.09,56.42c-2.61-3.58-4.67-3.45-6.85-2.66a4.59,4.59,0,0,0-1.43.8c-2.63,2.28-1.75,6.27-.72,8.66l7.58,17.3,8.23,17.2c4.38,9.17,12.47,21.43,26.36,21.17,0,0,2.86.17,9.79.22a22.93,22.93,0,0,0,22.73-18.77C103.17,81.68,103.92,59,103.92,59,103.92,55.85,102.7,53.13,99.4,52.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_035-4",
    d: "M45.23,20.28c-1.6-.5-4.84-.71-6.31.08a3.58,3.58,0,0,0-1.64,1.88c-.44,1.15.35,2.54,1.49,3.29,1.58,1,3.79.84,5.15.6a7.31,7.31,0,0,0,3.17-1.36A67.29,67.29,0,0,1,57.18,19.3c1.54-.71,4.55-1.15,6-.48a3.31,3.31,0,0,1,1.19,1,2.74,2.74,0,0,1-.34,3.48,6.7,6.7,0,0,1-3,1.95c-3.11.7-5,.14-7.71-1.22A57.76,57.76,0,0,0,45.23,20.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_035-4",
    d: "M50.4,22.12c2.24,3.56,3.58,7.63,5.84,11.18A7.31,7.31,0,0,0,60,36.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_035-4",
    d: "M51.12,23.06a3.82,3.82,0,0,1-.29,1.85L47,36.56a20.27,20.27,0,0,1-1.76,4.24c-.59,1-1.54,1.93-2.62,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_035-4",
    d: "M50.91,23.54A.81.81,0,0,0,52,22.82.93.93,0,0,0,51,22a1.13,1.13,0,0,0-1,1,.76.76,0,0,0,.22.63,1.09,1.09,0,0,0,.61.21,1.38,1.38,0,0,0,.64,0,.44.44,0,0,0,.31-.49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128035);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_035.ec3daa198bbfc79c5e55aaa1b661f03e.svg";
export { ForwardRef as ReactComponent };